import autobind from 'autobind-decorator';
import { navigateTo } from '#imports';
import { Injectable } from '@kaokei/use-vue-service';
import { getMyMessageList, setMessageView } from '~/api/admin/forum';
import type { UserMessageVo } from '~/types/auto/forum';

@Injectable()
export class MessageService {
  public list: UserMessageVo[] = [];
  public showDot = false;

  public init() {
    getMyMessageList().then((res) => {
      this.list = res || [];
      this.showDot = this.list.length > 0;
    });
  }

  public handleClickMessage(item: UserMessageVo) {
    // 管理删除1 用户回复2 举报帖子/评论3 题解审核通过4 审核不通过5 选择题解为精华题解6 审核通过并加精7 创建或修改讨论8
    // 3和8不会出现在消息列表
    if ([2, 4, 6, 7].includes(item.messageType as number)) {
      const url = `/${item.zone}/discuss/post/detail?id=${item.posterId}&type=${item.posterType}`;
      navigateTo(url, {
        open: {
          target: '_blank',
        },
      });
    } else if (item.messageType === 5) {
      // 审核不通过跳转到个人主页-我的题解
      // todo：因为目前只有题解有人审的审核不通过
      // 后续讨论也会增加审核不通过，则需要跳转到我的讨论页面
      navigateTo(
        { name: 'oj_home_solution' },
        {
          open: {
            target: '_blank',
          },
        },
      );
    }
    window.hetaoTrack('element_click', {
      element_name: '消息通知-点击内容',
      message_type: item.messageType,
      thread_id: `${item.posterId}`,
      thread_type: `${item.posterType}`,
    });
  }

  @autobind
  public handleOpenChange(visible: boolean) {
    if (visible) {
      if (this.list && this.list.length > 0) {
        const messageId = this.list.map((item) => item.id as number);
        setMessageView({ messageId }).then(() => {
          this.showDot = false;
        });
      }
    }
  }

  public getMsgShowEvent(item: UserMessageVo) {
    return {
      element_name: '消息通知',
      message_type: item.messageType,
      thread_id: `${item.posterId}`,
      thread_type: `${item.posterType}`,
    };
  }
}
